let currentDate = new Date().toLocaleDateString('sv-SE')
let date = new Date()

//  #####   ######  ##     ##
//  ##  ##    ##    ####   ##
//  #####     ##    ##  ## ##
//  ##  ##    ##    ##    ###
//  #####     ##    ##     ##
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-publishDate-set')
  if (!item) {
    return
  }
  const parent = item.closest('.js-publishDate') // 親グループ
  const type = item.dataset.type // 入力内容　current/limit

  setDatetime(parent, type, true)
})
//   ####  ######    ###    #####    ######
//  ##       ##     ## ##   ##  ##     ##
//   ###     ##    ##   ##  #####      ##
//     ##    ##    #######  ##  ##     ##
//  ####     ##    ##   ##  ##   ##    ##
// アクセス時の自動入力
const publishList = document.querySelectorAll('.js-publishDate-set[data-type="current"]')
for (const publish of publishList) {
  const parent = publish.closest('.js-publishDate') // 親グループ
  const type = 'current' // 入力内容　current/limit

  setTimeout(() => {
    setDatetime(parent, type, false) // 上書き禁止で実行
  }, 500)
}

//   ####  #####  ######
//  ##     ##       ##
//   ###   #####    ##
//     ##  ##       ##
//  ####   #####    ##
/**
 *
 * @param {element} parent 親要素
 * @param {String} type 入力タイプ　current/limit
 * @param {Boolean} overwrite 既に入力があっても上書きする
 */
function setDatetime(parent, type, overwrite = true) {
  const inputDate = parent.querySelector('.js-publishDate-date')
  const inputHour = parent.querySelector('.js-publishDate-hour')
  const inputMinute = parent.querySelector('.js-publishDate-minute')

  if (!overwrite) {
    // 上書き禁止
    if ((inputDate.value !== '') | (inputHour.value !== '') | (inputMinute.value !== '')) {
      // 入力済みの項目があれば処理しない
      return
    }
  }

  let datetimeList = {
    // セットする日時　初期状態は無期限日時
    date: '9999/12/31',
    hour: '00',
    minute: '00',
  }
  if (type === 'current') {
    // 現在日時に切り替え
    datetimeList = getNowDatetime() // 現在日時を取得

    // if (datetimeList['hour'] === '00') {
    //   // 0時を24時に置き換え
    //   datetimeList['hour'] === '24'
    // }
  }

  inputDate.value = datetimeList['date']
  inputHour.value = datetimeList['hour']
  inputMinute.value = datetimeList['minute']

  if (inputHour.tagName === 'SELECT') {
    // セレクトボックス時の処理
    // 分を5の倍数で丸める
    datetimeList['minute'] = num5(datetimeList['minute'])

    // 2桁に揃える
    datetimeList['hour'] = String(datetimeList['hour']).padStart(2, '0')
    datetimeList['minute'] = String(datetimeList['minute']).padStart(2, '0')

    // 選択を消す
    let selectList = inputHour.querySelectorAll('option')
    for (const element of selectList) {
      element.removeAttribute('selected')
    }
    selectList = inputMinute.querySelectorAll('option')
    for (const element of selectList) {
      element.removeAttribute('selected')
    }

    // 選択を切り替える
    // console.log(datetimeList)
    // console.log(inputHour)
    // console.log(inputMinute)

    inputHour.querySelector('option[value="' + datetimeList['hour'] + '"]').setAttribute('selected', '')
    inputHour.setAttribute('placeholder', datetimeList['hour'])
    inputMinute.querySelector('option[value="' + datetimeList['minute'] + '"]').setAttribute('selected', '')
    inputMinute.setAttribute('placeholder', datetimeList['minute'])

    if (inputHour.classList.contains('complete')) {
      // セレクトボックスを独自に変更している場合は解除
      inputHour.classList.remove('complete')
      inputHour.nextElementSibling.parentNode.removeChild(inputHour.nextElementSibling)
      unwrap(inputHour.parentNode) // 親を外す

      inputMinute.classList.remove('complete')
      inputMinute.nextElementSibling.parentNode.removeChild(inputMinute.nextElementSibling)
      unwrap(inputMinute.parentNode) // 親を外す

      window.selectSetup() // セレクトボックスの初期化
    }
  }

  // 指定した要素を削除して子要素を残す
  // unwrap(document.querySelector('.hoge'))
  function unwrap(target) {
    while (target.firstChild) {
      target.parentNode.insertBefore(target.firstChild, target)
    }
    target.remove()
  }
}

//   ####    #####  ######
//  ##       ##       ##
//  ##  ###  #####    ##
//  ##   ##  ##       ##
//   ####    #####    ##

/**
 * 現在日時を配列で返す
 */
function getNowDatetime() {
  const date = new Date()
  const year = date.getFullYear()
  const mon = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const min = date.getMinutes()
  const datetimeList = []

  datetimeList['date'] = year + '/' + String(mon).padStart(2, '0') + '/' + String(day).padStart(2, '0')
  datetimeList['hour'] = String(hour).padStart(2, '0')
  datetimeList['minute'] = String(min).padStart(2, '0')
  return datetimeList
}

//  ##     ##  ##   ##  ###    ###            ######
//  ####   ##  ##   ##  ## #  # ##            ##
//  ##  ## ##  ##   ##  ##  ##  ##  ########  #####
//  ##    ###  ##   ##  ##      ##                ##
//  ##     ##   #####   ##      ##            #####
// 整数を5の倍数に丸める
function num5(num) {
  let setNum = Math.round(Number(num) / 5) * 5 - 5
  if (setNum < 0) {
    setNum = 0
  }
  return setNum
}
